import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// import './lib/hide-header';
// import './lib/toggle';
import './lib/toggle-instructions';
import './lib/scrollto';

